export const LOCALSTORAGE_KEY = 'adminbase'
export const DEFAULT_FETCH_CUANTOS = 10

export const TIPO_NOTICIA_NORMAL = 'normal'